import type { FC, ReactElement } from 'react';
import { Navigate, type RouteProps } from 'react-router';
import { useIntl } from 'react-intl';

import PrivateRoute from './privateRoute';
import { getUserFromLocalStorage } from '../../Utils/sidebar';
import { isWhiteLabelAdmin } from '../../Utils/whiteLabel';

export interface WrapperRouteProps {
  titleId: string;
  auth?: boolean;
  roles?: string[];
}

const WrapperRouteComponent: FC<WrapperRouteProps & RouteProps> = ({
  titleId,
  auth,
  roles,
  ...props
}) => {
  const { formatMessage } = useIntl();

  const user = getUserFromLocalStorage();
  const userRole = user?.role;
  const isWhiteLabel = isWhiteLabelAdmin();

  if (titleId) {
    document.title = formatMessage({
      id: titleId,
    });
  }

  if (!isWhiteLabel && roles && roles.length > 0) {
    const hasAccess = roles.includes(userRole);
    if (!hasAccess) {
      return <Navigate to="/403" replace />;
    }
  }

  return auth ? (
    <PrivateRoute element={props.element as ReactElement} roles={roles} />
  ) : (
    (props.element as ReactElement)
  );
};

export default WrapperRouteComponent;
